import AppState, { SCREENS } from '../../../js/AppState';

import classes from './Module.module.css';
import Texts from 'react-sdk/Texts';
import clsx from 'clsx';
import Button from '@/components/shared/Button/Button';
import { useEffect, useState } from 'react';
import star_filled from './star_filled.png'
import star_empty from './star_empty.png'
import { FaLock } from 'react-icons/fa6';

const Star = ({filled}) => <img src={filled ? star_filled : star_empty} className={classes.star} />


const StarsButton = ({children, onClick, locked, disabled, disabledMessageDiv, starsNb}) => {

  return (
    <div className={clsx(classes.StarsButton, (locked || disabled) && classes.disabled)}  >


      {!locked &&
      <>
        <div className={classes.StarsButton_icon}>
          <Star filled={starsNb > 0} />
          <Star filled={starsNb > 1} />
          <Star filled={starsNb > 2} />
        </div>
      </>}
      {locked &&
      <div className={classes.StarsButton_icon}>
        <FaLock />
      </div>}
      <Button onClick={!disabled ? onClick : undefined} className={classes.StarsButton_btn}>
        {children}
        {disabledMessageDiv &&
        /*<div className={classes.StarsButton_tooltip} dangerouslySetInnerHTML={{__html:disabledMessage}}>*/
        <div className={classes.StarsButton_tooltip} >
          {disabledMessageDiv}
        </div>}
      </Button>

    </div>
  )
}

const ToolTipMessage = ({moduleEvalDone, moduleStarsTraining, prevEvalDone}) => {
  const starStyle = { }
  //starStyle.transform = "scale(0.5)";
  starStyle.display = "inline-block";
  starStyle.transformOrigin = "bottom center";
  starStyle.margin = "0 -5px";
  starStyle.height = "22px";
  return (
    <>
    {moduleEvalDone ?
      <div>Evaluation effectuée</div> :
      <>
      {(moduleStarsTraining < 3) ?
        <>
          {prevEvalDone ?
          <div>3 <span style={starStyle}><Star filled /></span> requises à l'entrainement</div> :
          <div>3 <span style={starStyle}><Star filled /></span> requises à l'entrainement<br/>Finir l'évaluation du niveau précédent</div>
          }
        </> :
        <>
          {!prevEvalDone &&
          <div>Finir l'évaluation du niveau précédent</div>}
        </>
      }
      </>
    }
    </>
  );
}

const Module = ({id, bgImageLink, disabled=false, toUnlock=false, onUnlockDone=null, extended, onClick}) => {

  const [transitioning, setTransitioning] = useState(false);

  const moduleKey = "module" + id;
  const moduleEvalDone = AppState.moduleStars[moduleKey].evaluation != null;
  let moduleStarsTraining = AppState.moduleStars[moduleKey].training;
  if (moduleStarsTraining == null)
    moduleStarsTraining = 0;
  let moduleStarsEval = AppState.moduleStars[moduleKey].evaluation;
  if (moduleStarsEval == null)
    moduleStarsEval = 0;

  let prevEvalDone = id == 1 ? true : AppState.moduleStars["module" + (id-1)].evaluation != null;

  let showToolTipMsg = null
  if (moduleEvalDone || !prevEvalDone || moduleStarsTraining < 3)
    showToolTipMsg = <ToolTipMessage moduleEvalDone={moduleEvalDone} moduleStarsTraining={moduleStarsTraining} prevEvalDone={prevEvalDone} />

  useEffect(() => {

    setTransitioning(extended)

    return () => {

    }
  }, [extended]);

  return (
    <div
    className={clsx(classes.Module, extended && classes.extended, transitioning && classes.transitioning, disabled && classes.disabled)}
    onClick={!disabled ? onClick : undefined}
    >


      <div className={classes.image_ctnr}>
        <div className={classes.image} style={{backgroundImage: `url(${"data/images/" + bgImageLink})`}}></div>
      </div>
      <div className={classes.footer}>
        <div className={classes.title}>{Texts.get("module_" + id + "_title")}</div>

        <div className={classes.description} dangerouslySetInnerHTML={{__html: Texts.get("module_" + id + "_description")  }} />

        {/* {extended && */}
        {!disabled &&
        <div className={classes.btns}>
          <StarsButton starsNb={moduleStarsTraining} onClick={() => AppState.launchModule(id, false)}>
            Entrainement
          </StarsButton>

          <StarsButton starsNb={moduleStarsEval} onClick={() => AppState.launchModule(id, true)}>
            Évaluation
          </StarsButton>

        </div>
        }

        {disabled &&
      <div className={clsx(classes.lock_overlay, toUnlock && classes.unlock)} onAnimationEnd={() => {
          console.log("ANIMEND")
          onUnlockDone()}} >
        <div className={classes.lock_overlay_icon}>
          <FaLock />
        </div>
      </div>}

      </div>
    </div>
  );
};

export default  Module